function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import defaultPropTypes from '@demant/locations-spot/lib/js/utils/prop-types';
import OticonLocationDetailForm from './location-detail-form';

var renderComponentWithSelector = function renderComponentWithSelector(selector, key) {
  var component = document.querySelector(selector);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    key: key || selector.substring(1),
    className: component.classList.toString(),
    dangerouslySetInnerHTML: {
      __html: component.innerHTML
    }
  }));
};

var LocationDetail = function LocationDetail(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      formDidSubmit = _useState2[0],
      setFormDidSubmit = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      formSubmitError = _useState4[0],
      setFormSubmitError = _useState4[1];

  var location = props.locations.find(function (loc) {
    return loc.UniqueId.toString() === props.match.params.id.toString();
  });

  var phoneClickHandler = function phoneClickHandler() {
    window.location.href = "tel:".concat(location.Phone);
    window.DGS.Event.getInstance().trigger('trackLocationsPhoneNumber', location.Name, location.PostalCode);
  };

  var websiteClickHandler = function websiteClickHandler() {
    window.open(location.Homepage);
    window.DGS.Event.getInstance().trigger('trackLocationsWebsiteLink', location.Name, location.PostalCode);
  };

  var getDirections = function getDirections() {
    window.open("http://maps.google.com/maps?&daddr=".concat(location.Latitude, ",").concat(location.Longitude));
  };

  var handleFormSubmitSuccess = function handleFormSubmitSuccess() {
    setFormDidSubmit(true);
  };

  var handleFormSubmitError = function handleFormSubmitError() {
    setFormSubmitError(true);
  };

  var handleFormWillSubmit = function handleFormWillSubmit() {
    setFormSubmitError(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "location-detail"
  }, location && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, location.Name)), /*#__PURE__*/React.createElement("button", {
    className: "close-button",
    onClick: function onClick(e) {
      props.onCloseLocation(e);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("strong", null, location.Name)), /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info-left-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "address"
  }, location.Address), /*#__PURE__*/React.createElement("div", {
    className: "address"
  }, location.PostalCode, " ", location.City), /*#__PURE__*/React.createElement("div", {
    className: "phone"
  }, "".concat(props.settings.dictionary.phone, " :"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: phoneClickHandler,
    title: location.Phone
  }, location.Phone)), location.Homepage && /*#__PURE__*/React.createElement("div", {
    className: "website"
  }, "".concat(props.settings.dictionary.website, ": "), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: websiteClickHandler,
    title: location.Homepage
  }, new URL(location.Homepage).host)), location.Email && /*#__PURE__*/React.createElement("div", {
    className: "email"
  }, "".concat(props.settings.dictionary.email, ": "), /*#__PURE__*/React.createElement("a", {
    href: "mailto:".concat(location.Email)
  }, location.Email)), location.OpeningHours && /*#__PURE__*/React.createElement("div", {
    className: "opening-hours"
  }, "".concat(props.settings.dictionary.openingHours, ": "), location.OpeningHours), location.Description && /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, "".concat(props.settings.dictionary.info, ": "), location.Description), /*#__PURE__*/React.createElement("div", {
    className: "distance"
  }, /*#__PURE__*/React.createElement("i", null, "".concat(props.distance, " ").concat(props.settings.Unit, " ").concat(props.settings.dictionary.fromYourLocation))), /*#__PURE__*/React.createElement("div", {
    className: "directions"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: getDirections
  }, "".concat(props.settings.dictionary.getDirections))))), props.settings.Form && !formDidSubmit && /*#__PURE__*/React.createElement(OticonLocationDetailForm, _extends({}, props.settings.Form, {
    configurationId: props.settings.Id,
    onFormSubmitSuccess: handleFormSubmitSuccess,
    onFormSubmitError: handleFormSubmitError,
    onFormWillSubmit: handleFormWillSubmit,
    clinicShortName: location.contactDetailsToString(['Name']),
    clinicEmail: location.Email,
    clinicDetails: location.contactDetailsToString(['Name', 'Address', 'PostalCode', 'City', 'Country', 'Phone', 'Email'])
  })), formDidSubmit && /*#__PURE__*/React.createElement("div", {
    className: "location-details__form-submit-success-wrapper"
  }, renderComponentWithSelector(props.formSubmitSuccessComponentSelector)), formSubmitError && /*#__PURE__*/React.createElement("div", {
    className: "location-details__form-submit-error-wrapper"
  }, renderComponentWithSelector(props.formSubmitErrorComponentSelector))));
};

LocationDetail.propTypes = {
  onCloseLocation: defaultPropTypes.func,
  settings: defaultPropTypes.settings.isRequired,
  locations: defaultPropTypes.locations.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object.isRequired,
  distance: PropTypes.string.isRequired,
  formSubmitSuccessComponentSelector: defaultPropTypes.string,
  formSubmitErrorComponentSelector: defaultPropTypes.string
};
LocationDetail.defaultProps = {
  onCloseLocation: defaultPropTypes.defaultOnCloseLocation,
  formSubmitSuccessComponentSelector: ':not(.location-details__form-submit-success-wrapper) > .location-form-submit-success',
  formSubmitErrorComponentSelector: ':not(.location-details__form-submit-error-wrapper) > .location-form-submit-error'
};
export default withRouter(LocationDetail);